import type { ReactNode } from 'react';

import { ApiError, NetworkError } from '../api/errors';
import { cn } from '../lib/cn';

// The server's own sentence and its field findings, then status · code · requestId: a refusal
// reduced to "Something went wrong" is the failure postmortem.md names first.
export const RefusalNote = ({
  error,
  lead,
  className,
}: {
  error: unknown;
  lead?: ReactNode;
  className?: string;
}) => {
  const api = error instanceof ApiError ? error : null;
  const message =
    error instanceof NetworkError
      ? 'The request never left. Nothing was changed.'
      : api
        ? api.message
        : String(error);
  const details = api?.rawDetails;
  const facts =
    typeof details === 'object' && details !== null && !Array.isArray(details)
      ? Object.entries(details).flatMap(([key, value]) =>
          (typeof value === 'number' || typeof value === 'string') && !key.endsWith('Id')
            ? [`${key}: ${typeof value === 'number' ? value.toLocaleString('en-US') : value}`]
            : [],
        )
      : [];
  return (
    <div
      role="alert"
      className={cn('rounded-control bg-danger-surface px-flat-lg py-flat text-meta', className)}
    >
      <p className="leading-18 text-primary">
        {lead && <span className="font-medium">{lead}: </span>}
        {message}
      </p>
      {api && api.fieldErrors.length > 0 && (
        <ul className="mt-1 leading-18 text-muted">
          {api.fieldErrors.map((fieldError) => (
            <li key={`${fieldError.field}:${fieldError.message}`}>
              <span className="font-mono text-primary">{fieldError.field}</span> —{' '}
              {fieldError.message}
            </li>
          ))}
        </ul>
      )}
      {facts.length > 0 && (
        <p className="mt-1 font-mono text-micro text-muted">{facts.join(' · ')}</p>
      )}
      {api && (
        <p className="mt-1 font-mono text-micro text-faint">
          {[api.status, api.code, api.requestId].filter(Boolean).join(' · ')}
        </p>
      )}
    </div>
  );
};
